import MetaChip from "./MetaChip";
import { getRelevanceTone } from "../../../utils/opportunityCard";

/** Full meta row for expanded/detail views only — not shown on card previews. */
export default function OpportunityMetaRow({
    industry,
    category,
    eventName,
    relevanceScore,
}) {
    const hasMeta = industry || category || eventName || relevanceScore != null;
    if (!hasMeta) return null;

    return (
        <div className="flex min-w-0 flex-wrap items-center gap-2">
            {industry ? (
                <MetaChip className="bg-violet-50 text-violet-700">{industry}</MetaChip>
            ) : null}
            {category ? (
                <MetaChip className="bg-sky-50 text-sky-700">{category}</MetaChip>
            ) : null}
            {eventName ? (
                <MetaChip className="bg-slate-100 text-slate-600">{eventName}</MetaChip>
            ) : null}
            {relevanceScore != null ? (
                <MetaChip className={getRelevanceTone(relevanceScore)}>
                    <i className="bi bi-graph-up-arrow me-1" aria-hidden />
                    {relevanceScore}% relevant
                </MetaChip>
            ) : null}
        </div>
    );
}
